exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1lE1xWaFNLqlqHwwhC_cQE{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}._1GBZ-YOxrU3_fJjksvRhLv{height:10.57143rem!important}.ZXPobDcpafboKwctMHJQT{font-weight:700;font-size:1rem;text-align:center;color:var(--colorText);margin-top:.14286rem}._3SBG0hu3E2KZpgap-KKKQR{color:#de4c4c}._6ZF4tA7JfcJjZ_FFL8hfb [data-prop=localName]{font-size:.85em}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentSelect": "_1lE1xWaFNLqlqHwwhC_cQE",
	"StudentSelect_option": "_1GBZ-YOxrU3_fJjksvRhLv",
	"StudentSelect_score": "ZXPobDcpafboKwctMHJQT",
	"StudentSelect_score__fail": "_3SBG0hu3E2KZpgap-KKKQR",
	"StudentCard_hfv4": "_6ZF4tA7JfcJjZ_FFL8hfb"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/UnitReportHFv4/StudentReportView/StudentSelect/style.postcss
// module id = 1940
// module chunks = 0